export enum FeatureFlag {
    WccAnalytics = 'WCCAnalytics',    
    ExternalWCAGAccessibilityObserver ='ExternalWCAGAccessibilityObserver'
}